import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigation } from '../../context/NavigationContext';
import { useLanguage } from '../../context/LanguageContext';

const BackButton = ({ 
  onClick, 
  className = '', 
  variant = 'link',
  showText = true,
  size = 'md'
}) => {
  const { canGoBack, goBack } = useNavigation();
  const { t } = useLanguage();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (canGoBack) {
      goBack();
    } else {
      // Fallback to browser history
      window.history.back();
    }
  };

  return (
    <Button 
      variant={variant} 
      className={`back-button d-inline-flex align-items-center ${className}`}
      onClick={handleClick}
      size={size}
    >
      <i className="bi bi-arrow-left me-2"></i>
      {showText && <span>{t('common.back') || 'Back'}</span>}
    </Button>
  );
};

export default BackButton;

